import axios from 'axios';
import Vue from 'vue';

import AnalyticsService from '../service/analyticsService';
import config from '../config';
import Logger from '../service/logger';
import RestApiDao from '../service/restApiDao';
import SuuntoService from '../service/suuntoService';
import EventBus from '../service/eventBus';
import WebsocketClient from '../service/websocketClient';
import store from '../store/store';
import DemoService from '../service/demoService';
import DataImportService from '../service/dataImportService';
import NoticeService from '../service/noticeService';
import router from '../router';
import MemberService from '../service/memberService';
import DeviceFactory from '../service/device/deviceFactory';
import DiaryService from '../service/diaryService';
import WorkoutService from '../service/workoutService';
import GarminSetupStrategy
  from '../components/secondary/account/signup/setup/strategy/garminSetupStrategy';
import SuuntoSetupStrategy
  from '../components/secondary/account/signup/setup/strategy/suuntoSetupStrategy';
import PolarSetupStrategy
  from '../components/secondary/account/signup/setup/strategy/polarSetupStrategy';
import SuuntoV2SetupStrategy
  from '../components/secondary/account/signup/setup/strategy/suuntoV2SetupStrategy';
import CorosSetupStrategy
  from '../components/secondary/account/signup/setup/strategy/corosSetupStrategy';
import AppleSetupStrategy
  from '@/components/secondary/account/signup/setup/strategy/appleSetupStrategy';

// Inject the container into all Vue components.
Vue.mixin({
  beforeCreate() {
    const options = this.$options;
    if (options.container) {
      this.$container = options.container;
    } else if (options.parent && options.parent.$container) {
      this.$container = options.parent.$container;
    }
  },
});

/*
 * An instance of Container is automatically injected into all Vue components.
 * It can be accessed via this.$container.
 */
export default class Container {
  constructor(integrateSentryWithVue = true) {
    // Define services here.
    this.apiHttpClient = axios.create({
      baseURL: `${config.apiProtocol}://${config.apiUrl}${config.apiBasePath}`,
    });
    this.config = config;
    this.store = store;
    this.router = router;
    this.logger = new Logger(config.Node, integrateSentryWithVue);
    this.eventBus = new EventBus(this.logger);
    this.analytics = new AnalyticsService(Vue.gtm);
    this.dao = new RestApiDao(this.logger, this.apiHttpClient, this.store, this.config);
    this.deviceFactory = new DeviceFactory(this.logger, this.store, this.config, this.dao, this.eventBus);
    this.di = new DataImportService(
      this.logger,
      this.eventBus,
      this.store,
      this.dao,
      this.config,
      this.deviceFactory,
    );
    this.suunto = new SuuntoService(this.dao, this.logger);
    this.demo = new DemoService(this.logger, this.dao, store);

    this.websockets = new WebsocketClient(
      this.eventBus,
      this.store,
      this.logger,
      this.config.WebsocketEndpoint,
      this.config.region,
    );
    this.notice = new NoticeService(this.logger, this.router, this.store, this.eventBus);
    this.workoutService = new WorkoutService(this.logger, this.store);
    this.memberService = new MemberService(this.logger, this.eventBus, this.store, this.dao);
    this.setupStrategies = {
      garmin: new GarminSetupStrategy(
        this.logger, this.store, this.eventBus, this.di, this.memberService, this.router,
      ),
      suunto: new SuuntoSetupStrategy(
        this.logger, this.store, this.eventBus, this.di, this.memberService, this.router,
      ),
      polar: new PolarSetupStrategy(
        this.logger, this.store, this.eventBus, this.di, this.memberService, this.router,
      ),
      suuntoV2: new SuuntoV2SetupStrategy(
        this.logger, this.store, this.eventBus, this.di, this.memberService, this.router,
      ),
      coros: new CorosSetupStrategy(
        this.logger, this.store, this.eventBus, this.di, this.memberService, this.router,
      ),
      apple: new AppleSetupStrategy(
        this.logger, this.store, this.eventBus, this.di, this.memberService, this.router,
      ),
    };
    this.diaryService = new DiaryService(this.dao);
  }
}
